import { httpConsulta } from "../../../../services/apiManagement/Http.interceptor";

export const getAllPlates = (data: string) => {
    return httpConsulta.get(`/getVeiculoByCd?cd=${data}`);
}

export const getStatusVehicles = (data: string) => {
    return httpConsulta.get(`/getVeiculoByPlaca?placa=${data}`);
}

export const postEntranceVehicles = (data: {veiculo: string}) => {
    return httpConsulta.post(`/GravaEntradaVeiculoPlaca`, data);
}

export const postExitVehicles = (data: {veiculo: string}) => {
    return httpConsulta.post(`/GravaSaidaVeiculoPlaca`, data);
}